export default __webpack_public_path__ + "static/media/index.ef528b03.less";